import React from 'react'
import Button from '@material-ui/core/Button'
import GetAppTwoToneIcon from '@material-ui/icons/GetAppTwoTone'
import { saveAs } from 'file-saver'

function GeneratedQR({value, searchValue, format}) {

    const downloadFile = () => {
        if (value.includes('https://')) {
            var test1 = value.replace('https://', '')
            var fileName = test1 + '-qr.'+format
        }
        else if (value.includes('http://')){
            var test2 = value.replace('http://', '')
            fileName = test2 + '-qr.'+format
        }

        fetch(searchValue)
            .then(response => response.blob())
            .then(blob => saveAs(blob, fileName))            
    }

    

    return (
        <div className="generatedqr">
            <Button
                color="primary"
                endIcon={<GetAppTwoToneIcon/>}
                onClick={() => downloadFile()}
            >
            Download
            </Button>
        </div>
    )
}

export default GeneratedQR
